<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        {{ edit ? `Edit Stream Scheme` : "Add Stream Scheme" }}
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="6"
            ><v-select
              v-model.trim="form.stream_id"
              label="Stream"
              :items="streams"
              item-text="name"
              item-value="id"
              outlined
              dense
              bottom
              :readonly="stream_id != null"
              :append-icon="stream_id != null ? '' : 'mdi-menu-down'"
              hide-details="auto"
              :rules="[rules.required]"
          /></v-col>
          <v-col cols="6"
            ><v-select
              v-model.trim="form.program_id"
              label="Programme*"
              :items="programs"
              :item-text="
                (program) =>
                  `${program.degree?.short_name || ''}  ${
                    program.specialization ? ' - ' : ''
                  } ${program.specialization || ''}`
              "
              item-value="id"
              outlined
              dense
              bottom
              hide-details="auto"
              :readonly="program_id != null"
              :append-icon="program_id != null ? '' : 'mdi-menu-down'"
              :rules="[rules.required]"
          /></v-col>
          <v-col cols="6"
            ><v-select
              v-model.trim="form.program_scheme_id"
              label="Programme Scheme*"
              :items="program_schemes"
              item-text="name"
              item-value="id"
              outlined
              dense
              bottom
              hide-details="auto"
              :rules="[rules.required]"
          /></v-col>
          <v-col cols="3"
            ><v-autocomplete
              v-model.trim="form.year"
              label="Year*"
              outlined
              dense
              :items="years"
              :rules="[rules.required]"
              hide-details="auto"
          /></v-col>
          <v-col cols="3"
            ><v-select
              v-model.trim="form.batch"
              label="Batch*"
              :items="[1, 2]"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
          /></v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0 mb-3 mx-2">
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save">{{
          edit ? "Update" : "Save"
        }}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { rules } from "@/helpers/rules";

export default {
  props: {
    stream_scheme: {
      type: Object,
      default: () => {},
    },
    programs: {
      type: Array,
      default: () => [],
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
    program_id: {
      type: Number,
      default: () => null,
    },
    streams: {
      type: Array,
      default: () => [],
    },
    stream_id: {
      type: Number,
      default: () => null,
    },
  },
  components: {},
  data() {
    return {
      rules,
      form: {
        department_id: null,
      },
      program_schemes: [],
      years: Array.from({ length: 15 }, (v, k) => k + new Date().getFullYear()),
    };
  },
  computed: {},
  created() {
    this.init();
    if (this.stream_id) this.form.stream_id = this.stream_id;
    if (this.program_id) this.form.program_id = this.program_id;
    this.getProgramSchemes();
  },
  watch: {
    program_schemes(val) {
      if (val.length === 1) {
        this.form.program_scheme_id = val[0].id;
      } else if (!val.find((item) => item.id === this.form.program_scheme_id)) {
        this.form.program_scheme_id = null;
      }
    },
  },
  methods: {
    async init() {
      if (this.edit) {
        this.form = { ...this.stream_scheme };
      }
    },

    getProgramSchemes() {
      this.$axios
        .get(`program_schemes?program_id=${this.program_id}`)
        .then((res) => {
          this.program_schemes = res.data.data;
        });
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$emit(this.edit ? "update" : "create", this.form);
      }
    },
  },
};
</script>

<style scoped></style>
